import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

export const Main = styled.div``

export const GalleryColumn = styled.div`
  margin-top: -10px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-top: -20px;
  }

  ${plume.Gallery} {
    position: sticky;
    top: 53px;
    // viewport height minus header, subheader and crumbs
    max-height: calc(100vh - ${plume.SIZES.HEADER_HEIGHT} - ${plume.SIZES.HEADER_SUB_NAV_HEIGHT} - 46px);
  }

  position: relative;
`

export const Container = styled(plume.Container)`
  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  ${GalleryColumn} {
    flex: 1 1 25%;
  }

  ${Main} {
    flex: 2;
  }
`
